import React, { Component, Fragment } from 'react';
import { Button, Form, Grid, Icon, Loader, Message, Popup, Table } from 'semantic-ui-react';
import { DateTimePicker } from 'react-widgets';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import SearchTableData from '../../util/SearchTableData';

class CourseGradingTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editingRowId: null,
            editedRowData: null,
            saving: false,
            includeGraded: true,
        };
    }

    handleEditClick = (course) => {
        this.setState({
            editingRowId: course.id,
            editedRowData: { ...course }
        });
    };

    handleCancelClick = () => {
        this.setState({
            editingRowId: null,
            editedRowData: null
        });
    };

    handleInputChange = (field, value) => {
        this.setState(prev => ({
            editedRowData: {
                ...prev.editedRowData,
                [field]: value
            }
        }));
    };

    handleSaveClick = () => {
        const {
            editingRowId,
            editedRowData
        } = this.state;
        this.setState({ saving: true });
        this.props.onSave(editingRowId, editedRowData)
            .then(() => {
                this.setState({ editingRowId: null, editedRowData: null, saving: false });
            })
            .catch(() => {
                this.setState({ saving: false });
            });
    };

    render() {
        const {
            courses,
            marks,
            loading,
            allCourses,
            getResults,
            onSearchTextChange,
        } = this.props;

        const {
            editingRowId,
            editedRowData,
            saving,
            includeGraded,
        } = this.state;

        const displayedCourses = includeGraded
            ? courses
            : courses.filter(c => c.markKey === 'nonp');

        if (loading) {
            return (
                <div style={{
                    paddingTop: '100px',
                    paddingBottom: '100px'
                }}>
                    <Loader active inline="centered"/>
                </div>
            );
        }

        return (
            <Form>
                <Table selectable celled compact textAlign="left" verticalAlign="middle">
                    <Table.Header>
                        {getResults && (
                            <Table.Row>
                                <Table.HeaderCell colSpan={21}>
                                    <Grid stackable verticalAlign="middle">
                                        <Grid.Column width={16}>
                                            <SearchTableData
                                                profMozilla
                                                data={allCourses}
                                                getResults={getResults}
                                                filterItem={['studentFullName']}
                                                onSearchTextChange={onSearchTextChange}
                                            />
                                        </Grid.Column>
                                    </Grid>
                                </Table.HeaderCell>
                            </Table.Row>
                        )}
                        <Table.Row>
                            <Table.HeaderCell colSpan={1}>
                                <FormattedMessage id="externalStudent.ordinalNumber"/>
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan={3}>
                                <FormattedMessage id="externalStudent.fullName"/>
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan={4}>
                                <FormattedMessage id="externalStudent.course"/>
                                <div style={{
                                    fontSize: '0.85em',
                                    color: '#999'
                                }}>
                                    {<FormattedMessage id="externalStudent.studyProgram"/>}
                                </div>
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan={3}>
                                <FormattedMessage id="externalStudent.courseCode"/>
                                - <FormattedMessage id="externalStudent.ects"/>
                                <div style={{
                                    fontSize: '0.85em',
                                    color: '#999'
                                }}>{<FormattedMessage id="externalStudent.lectureAndExerciseNumber"/>}
                                </div>
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan={3}>
                                <FormattedMessage id="externalStudent.attendanceType"/>
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan={3}>
                                <FormattedMessage id="externalStudent.examDate"/>
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan={2}>
                                <FormattedMessage id="externalStudent.grade"/>
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan={2} textAlign={"center"} verticalAlign={"middle"}>
                                <FormattedMessage id="externalStudent.includeGraded"/>
                                <Form.Checkbox
                                    checked={includeGraded}
                                    onChange={(e, { checked }) => this.setState({ includeGraded: checked })}
                                />
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {displayedCourses.map((course, index) => {
                            const isEditing = course.id === editingRowId;
                            const current = isEditing ? editedRowData : course;

                            return (
                                <Table.Row key={index} verticalAlign="middle">
                                    <Table.Cell colSpan={1} verticalAlign="middle" width={1}>{index + 1}.</Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle">
                                        {course.studentFullName}
                                    </Table.Cell>
                                    <Table.Cell colSpan={4} verticalAlign="middle">
                                            {course.isActivity ? course.activityName : course.courseName}
                                        <div style={{
                                            fontSize: '0.85em',
                                            color: '#999'
                                        }}>
                                            {course.isActivity
                                                ? <FormattedMessage id="externalStudent.otherActivityTypes"/>
                                                : (course.studyProgramBasicName + ' - ' + course.studyProgramName)
                                            }
                                        </div>
                                    </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle">
                                        {course.courseCode} - {course.ects} ECTS
                                        <div style={{
                                            fontSize: '0.85em',
                                            color: '#999'
                                        }}>
                                            {course.lectureNumber} / {course.exerciseNumber} / {course.otherNumber}
                                        </div>
                                    </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle">{course.attendanceTypeName}</Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle">
                                        {isEditing ? (
                                            <FormattedMessage id="externalStudent.enterExamDate">
                                                {msg => (
                                                    <DateTimePicker
                                                        format="D. M. YYYY."
                                                        time={false}
                                                        placeholder={msg}
                                                        value={current.dateOfExam ? new Date(current.dateOfExam) : null}
                                                        onChange={(value) => this.handleInputChange('dateOfExam', value)}
                                                    />
                                                )}
                                            </FormattedMessage>
                                        ) : (
                                            course.dateOfExam ? moment(course.dateOfExam)
                                                .format('D. M. YYYY.') : '-'
                                        )}
                                    </Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle">
                                        {isEditing ? (
                                            <Form.Select
                                                fluid
                                                options={marks}
                                                value={current.markId || null}
                                                placeholder={<FormattedMessage id="externalStudent.selectGrade"/>}
                                                clearable
                                                selection
                                                search
                                                compact
                                                onChange={(e, { value }) => this.handleInputChange('markId', value)}
                                            />
                                        ) : (
                                            course.markName
                                        )}
                                    </Table.Cell>
                                    <Table.Cell colSpan={2} textAlign="center" verticalAlign="middle">
                                        {isEditing ? (
                                            <Fragment>
                                                <Popup
                                                    content={<FormattedMessage id="externalStudent.save"/>}
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            circular
                                                            icon
                                                            size="tiny"
                                                            color="blue"
                                                            onClick={this.handleSaveClick}
                                                            loading={saving}
                                                            disabled={saving}
                                                        >
                                                            <Icon name="check"/>
                                                        </Button>
                                                    }
                                                />
                                                <Popup
                                                    content={<FormattedMessage id="externalStudent.cancel"/>}
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            basic
                                                            circular
                                                            icon
                                                            size="tiny"
                                                            color="blue"
                                                            onClick={this.handleCancelClick}
                                                            disabled={saving}
                                                        >
                                                            <Icon name="close"/>
                                                        </Button>
                                                    }
                                                />
                                            </Fragment>
                                        ) : (
                                            <Fragment>
                                                <Popup
                                                    content={<FormattedMessage id="externalStudent.edit"/>}
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            basic
                                                            circular
                                                            icon
                                                            size="tiny"
                                                            color="green"
                                                            disabled={saving || (editingRowId !== null && editingRowId !== course.id)}
                                                            onClick={() => this.handleEditClick(course)}
                                                        >
                                                            <Icon name="pencil"/>
                                                        </Button>
                                                    }
                                                />
                                                <Popup
                                                    content={<FormattedMessage id="externalStudent.studentProfile"/>}
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            basic
                                                            circular
                                                            icon
                                                            size="tiny"
                                                            color="blue"
                                                            onClick={() => this.props.onShowDetails(course)}
                                                        >
                                                            <Icon name="user"/>
                                                        </Button>
                                                    }
                                                />
                                            </Fragment>
                                        )}
                                    </Table.Cell>
                                </Table.Row>
                            );
                        })}
                        {displayedCourses.length === 0 && (
                            <Table.Row>
                                <Table.Cell colSpan={21} textAlign="left">
                                    <FormattedMessage id="externalStudent.noGrades"/>
                                </Table.Cell>
                            </Table.Row>
                        )}
                    </Table.Body>
                </Table>
            </Form>
        );
    }
}

export default CourseGradingTable;



// WEBPACK FOOTER //
// ./src/views/Professor/ProfessorInputGrades/CourseGradingTable.js